import { render, staticRenderFns } from "./Furniture.vue?vue&type=template&id=61628784&scoped=true&"
import script from "./Furniture.vue?vue&type=script&lang=js&"
export * from "./Furniture.vue?vue&type=script&lang=js&"
import style0 from "./Furniture.vue?vue&type=style&index=0&id=61628784&prod&scoped=true&lang=css&"
import style1 from "./Furniture.vue?vue&type=style&index=1&id=61628784&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61628784",
  null
  
)

export default component.exports